import { useState, useEffect } from 'react';

/**
 * Custom hook to handle referral codes from URL parameters
 * Detects ?referral=CODE in URL and manages the referral state
 */
export const useReferralFromURL = () => {
  const [referralCode, setReferralCode] = useState('');
  const [referralSource, setReferralSource] = useState(null); // 'url' or 'manual'

  useEffect(() => {
    // Check for referral code in URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const urlReferralCode = urlParams.get('referral');
    
    if (urlReferralCode) {
      // Clean the referral code (remove special characters, limit length)
      const cleanedCode = urlReferralCode.trim().toUpperCase().slice(0, 10);
      
      if (cleanedCode) {
        setReferralCode(cleanedCode);
        setReferralSource('url');
        
        // Store in sessionStorage to persist across navigation
        sessionStorage.setItem('referralCode', cleanedCode);
        sessionStorage.setItem('referralSource', 'url');
        
        // Clean up URL (remove referral parameter) for better UX
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('referral');
        window.history.replaceState({}, document.title, newUrl.toString());
        
        console.log('Referral code detected from URL:', cleanedCode);
      }
    } else {
      // Check sessionStorage for previously detected referral
      const storedCode = sessionStorage.getItem('referralCode');
      const storedSource = sessionStorage.getItem('referralSource');
      
      if (storedCode && storedSource) {
        setReferralCode(storedCode);
        setReferralSource(storedSource);
      }
    }
  }, []);

  const updateReferralCode = (newCode, isManual = true) => {
    const cleanedCode = newCode.trim().toUpperCase().slice(0, 10);
    setReferralCode(cleanedCode);
    
    if (isManual) {
      setReferralSource('manual');
      sessionStorage.setItem('referralSource', 'manual');
    }
    
    if (cleanedCode) {
      sessionStorage.setItem('referralCode', cleanedCode);
    } else {
      sessionStorage.removeItem('referralCode');
      sessionStorage.removeItem('referralSource');
    }
  };

  const clearReferralCode = () => {
    setReferralCode('');
    setReferralSource(null);
    sessionStorage.removeItem('referralCode');
    sessionStorage.removeItem('referralSource');
  };

  const generateReferralURL = (baseCode) => {
    if (!baseCode) return null;
    
    const baseURL = process.env.REACT_APP_BASE_URL || 'https://passly.xyz';
    return `${baseURL}?referral=${baseCode.toUpperCase()}`;
  };

  return {
    referralCode,
    referralSource,
    isFromURL: referralSource === 'url',
    updateReferralCode,
    clearReferralCode,
    generateReferralURL
  };
};